import {
  getProposalCompleted,
  getOndemandAssesmentCompleted,
  getQuotesCompleted,
  getRealizedBuyNow,
  getAutoBidCompleted,
  getBidCompleted,
} from "@/services/api/BuyerServiceApi";
import { searchByPlateAPI } from "@/services/api/SerchServiceApi";
import { PER_PAGE_BUYER_PAGINATION } from "@/views/buyer/constants/BuyerPagination";

const strategies = {
  proposalCompleted: (orderBy, period, page, per_page) =>
    getProposalCompleted(orderBy, period, page, per_page),

  onDemandAssessmentCompleted: (orderBy, period, page, per_page) =>
    getOndemandAssesmentCompleted(orderBy, period, page, per_page),

  quotesCompleted: (orderBy, period, page, per_page) =>
    getQuotesCompleted(orderBy, period, page, per_page),

  buyNowCompleted: (orderBy, period, page, per_page) =>
    getRealizedBuyNow(orderBy, period, page, per_page),

  autoBidCompleted: (orderBy, period, page, per_page) =>
    getAutoBidCompleted(orderBy, period, page, per_page),

  announcementCompleted: (orderBy, period, page, per_page) =>
    getBidCompleted(orderBy, period, page, per_page),
};

export async function getBuyerContent({
  type,
  plate,
  orderBy = null,
  period = null,
  page = 1,
  per_page = PER_PAGE_BUYER_PAGINATION,
} = {}) {

  if (plate) {
    const { data } = await searchByPlateAPI(plate);
    const tx = data?.payload?.transaction;
    const item = tx?.data ?? null;
    const isPackage = item?.qtdVeic && item.qtdVeic > 1;
    const list = item ? [item] : [];

    return {
      page: 1,                     
      totalPages: list.length ? 1 : 0,
      totalItems: list.length,
      result: {
        [tx?.type || (isPackage ? "packages" : "vehicles")]: list,
      },
    };
  }

  const strategy = strategies[type];
  if (!strategy) {
    throw new Error(`Tipo não suportado: ${type}`);
  }

  const raw = await strategy(orderBy, period, page, per_page);

  return ensurePaginatedShape(raw, { type, page });
}

function normalizeList(d) {
  if (Array.isArray(d)) return d;
  if (d && Array.isArray(d.items)) return d.items;
  if (d && Array.isArray(d.vehicles)) return d.vehicles;

  if (d && typeof d === "object") {
    if (d.result && typeof d.result === "object") {
      const firstKey = Object.keys(d.result)[0];
      const arr = firstKey ? d.result[firstKey] : null;
      if (Array.isArray(arr)) return arr;
    }
    const firstArray = Object.values(d).find((v) => Array.isArray(v));
    if (firstArray) return firstArray;
  }
  return [];
}

function ensurePaginatedShape(source, { type = "vehicles", page = 1 } = {}) {
  if (source && typeof source === "object" && source.page !== undefined) {
    // Já paginado. Garante que `result` exista e contenha uma lista.
    if (!source.result) {
      const list = normalizeList(source);
      return {
        ...source,
        result: { [type]: list },
        totalItems: Number(source.totalItems ?? list.length) || 0,
        totalPages: Number(source.totalPages ?? 1) || 1,
      };
    }
    return source;
  }

  const list = normalizeList(source);
  return {
    page: Number(page) || 1,
    totalPages: 1,
    totalItems: list.length,
    result: { [type]: list },
  };
}
